interface Props {
  /** The sentence itself. Shown on hover and on focus, never inline. */
  text: string;
}

/**
 * A short explanation that stays out of the way until it is wanted.
 *
 * Written as a marker rather than as a line of small text under the field
 * because a form whose every field carries two lines is a form nobody reads: the
 * explanations crowd out the labels, and the labels are what people scan for.
 * The hint is for the first time and for the doubtful case, and it is one hover
 * away in both.
 *
 * A `<button>` rather than a `<span>` so that it is reachable from the keyboard
 * — the browser shows a title on focus as well as on hover, and a hint that only
 * a mouse can reach is a hint half the room cannot.
 */
export function Hint({ text }: Props) {
  return (
    <button type="button" className="hint-mark" title={text} aria-label={text} tabIndex={0}>
      ?
    </button>
  );
}
